import { Space, Typography } from "antd";
import logo from "assets/img/logo2.png";
import "./index.css";

const Header = (props) => {

  const { isFininsh } = props;
  return (
    <>
      {/* <Row className="change-info-header"> */}
      <Space direction="vertical" align="center" className="">
        <img src={logo} className="logo" alt="logo" width={300} height="auto" />
        {!isFininsh && (
          <Typography.Title level={3} className="title-page">
            ĐIỀU CHỈNH THÔNG TIN CHỨNG THƯ SỐ USB TOKEN
          </Typography.Title>
        )}
      </Space>
      {/* </Row> */}
    </>
  );
};
export default Header;
